import React, { useEffect, useState } from "react";
import api from "../../api/axios";
import ModelSelect from "../ui/ModelSelect";

const MargeNetteTable = () => {
    const [chains, setChains] = useState([]);
    const [selectedChain, setSelectedChain] = useState("");
    const [selectedModel, setSelectedModel] = useState("");
    const [model, setModel] = useState(null);
    const [models, setModels] = useState([]);
    const [selectionType, setSelectionType] = useState(""); // "model" or "chain"
    const [systemConstant, setSystemConstant] = useState({
        Nombre_d_heures_par_jour: "",
        Taux_horaire_SMIG_16_29: "",
        Taux_horaire_17_00: "",
        Taux_horaire_17_50: "",
        Masse_salariale_16_29: "",
        Masse_salariale_17_00: "",
        Masse_salariale_17_50: "",
        Capacité_par_unité_transport: "",
        cotisation_entroprise_trans: "",
        Coût_par_trajet: "",
        Coût_énergie_journalier: "",
        Coût_charges_fixes_journalier: "",
    });
     const [totalHours, setTotalHours] = useState(0);
    const [selectedChainSortie, setSelectedChainSortie] = useState(0)
    const [totalSortie , setTotalSortie] = useState(0)
    const [fils, setFils] = useState(0);
    const [filsParChain , setFilsParChain] = useState(0)
    const [filsParChainPre , setFilsParChainPre] = useState(0)
    const [plastique, setPlastique] = useState(0);
    const [plastiqueParChain, setPlastiqueParChain] = useState(0);
    const [coûtEnergie, setCoûtEnergie] = useState(0);
    const [coûtChargesFixes, setCoûtChargesFixes] = useState(0);
    const [totalMassSalary, setTotalMassSalary] = useState(0);
    const [couteTransport, setCouteTransport] = useState(0);
    const [coûtDeRevient, setCoûtDeRevient] = useState(0);
    const [coûtDeRevientParChain, setCoûtDeRevientParChain] = useState(0);
    const [coûtDeRevientParChainPre, setCoûtDeRevientParChainPre] = useState(0);
    const [effectifDirect, setEffectifDirect] = useState(0);
    const [effectifDirectChain, setEffectifDirectChain] = useState(0);
    const [totalMassSalaryParChain, setTotalMassSalaryParChain] = useState(0)
    const [couteTransportParChain, setCouteTransportParChain] = useState(0)
    const [coûtEnergieParChain , setCoûtEnergieParChain] = useState(0)
    const [coûtChargesFixesParChain , setCoûtChargesFixesParChain] = useState(0)
    const [effectifInDirect, setEffectifInDirect] = useState(0);
    const [totalChains, setTotalChains] = useState(0);
    const [totalExport, setTotalExport] = useState(0);
    const [error , setError] = useState('');
    const [productionDepotValeur , setProductionDepotValeur] = useState(null)
    const [margeBruteDepot, setMargeBruteDepot] = useState(0)
    const [margeNetteDepot , setMargeNetteDepot] = useState(0)
    const [margeNetteDepotParChain , setMargeNetteDepotParChain] = useState(0)
    const [productionDepotValeurChain, setProductionDepotValeurChain] = useState(0)
    const [productionDepotValeurChainpre, setProductionDepotValeurChainPre] = useState(0)
    const [planTotal , setPlanTotal] = useState(0)
    const [plastiqueParChainPre , setPlastiqueParChainPre] = useState(0)
    const [margeNetteDepotParChainPre, setMargeNetteDepotParChainPre] = useState(0)
    const [effectifInDirectStandard ,setEffectifInDirectStandard] = useState(0)
    const [totalMassSalaryParChainPre, setTotalMassSalaryParChainPre] = useState(0)
    const [couteTransportParChainPre, setCouteTransportParChainPre] = useState(0)
    const [coûtChargesFixesParChainPre, setCoûtChargesFixesParChainPre] = useState(0)
    const [coûtEnergieParChainPre , setCoûtEnergieParChainPre] = useState(0)
    const [effectifDirectPr, setEffectifDirectPr] = useState(0)
    
    // Model selection state variables (from MargeNette.js approach)
    const [modelChains, setModelChains] = useState([]);
    const [modelProductionValue, setModelProductionValue] = useState(0);
    const [modelTotalCost, setModelTotalCost] = useState(0);
    const [modelNetMargin, setModelNetMargin] = useState(0);
    const [modelNetMarginRate, setModelNetMarginRate] = useState(0);
    const [modelDepotCost, setModelDepotCost] = useState(0);
    const [modelPlastiqueValue, setModelPlastiqueValue] = useState(0);
    const [modelDepotFinalValue, setModelDepotFinalValue] = useState(0);
    
    // Chain selection state variables (from MargeNetteChainChart.js approach)
    const [chainProductionValue, setChainProductionValue] = useState(0);
    const [chainTotalCost, setChainTotalCost] = useState(0);
    const [chainNetMargin, setChainNetMargin] = useState(0);
    const [chainNetMarginRate, setChainNetMarginRate] = useState(0);
    const [cle, setCle] = useState(0);
    const [workedHoursByDate, setWorkedHoursByDate] = useState({});
    const [effectiveDataByDate, setEffectiveDataByDate] = useState({});
    const [effectiveIndirectDataByDate, setEffectiveIndirectDataByDate] = useState({});
    const [effectiveIndirectThreeValuesByDate, setEffectiveIndirectThreeValuesByDate] = useState({});
    
    // Chain-specific calculation state variables
    const [chainTotalHours, setChainTotalHours] = useState(0);
    const [chainEffectifDirect, setChainEffectifDirect] = useState(0);
    const [chainEffectifInDirect, setChainEffectifInDirect] = useState(0);
    const [chainTotalMassSalary, setChainTotalMassSalary] = useState(0);
    const [chainCouteTransport, setChainCouteTransport] = useState(0);
    const [chainCoûtEnergie, setChainCoûtEnergie] = useState(0);
    const [chainCoûtChargesFixes, setChainCoûtChargesFixes] = useState(0);
    const [chainFilsParChain, setChainFilsParChain] = useState(0);
    const [chainTotalExport, setChainTotalExport] = useState(0);

    // Depot-specific calculation state variables (from MargeNette.js)
    const [modelDepotTransportCost, setModelDepotTransportCost] = useState(0);
    const [modelDepotMassSalary, setModelDepotMassSalary] = useState(0);
    const [modelDepotTotalCost, setModelDepotTotalCost] = useState(0);

    useEffect(() => {
      const fetchDepotValue = async () => {
        try {
          const response = await api.get(`/magasin_production/${selectedModel}`);
          setModelDepotFinalValue(response.data.value);
        } catch (error) {
          console.error("Error fetching depot value:", error);
          setModelDepotFinalValue(0);
        }
      };
      
      if (selectedModel) {
        fetchDepotValue();
      }
    }, [selectedModel]);

    useEffect(() => {
      console.log("Coût De Revient:", coûtDeRevient);
  }, [fils, plastique, totalMassSalary, couteTransport, coûtChargesFixes, coûtEnergie, coûtDeRevient]);

  useEffect(() => {
      console.log("Marge Nette Depot:", margeNetteDepot);
      console.log("Marge Nette Depot Par Chain:", margeNetteDepotParChain);
  }, [margeNetteDepot, margeNetteDepotParChain]);

    useEffect(() => {
        const fetchChains = async () => {
            try {
                const response = await api.get("/chains");
                setChains(response.data);
            } catch (error) {
                console.error("Error fetching chains:", error);
            }
        };

        fetchChains();
    }, []);

    useEffect(() => {
      const fetchPlan = async () => {
          try {
              const response = await api.get(`/product_plans_model/${selectedModel}/${selectedChain}`);
              const modelData = models.find((model) => {
                return model.id == selectedModel;
              });
              const productionDepotValeur = (
                modelData.prixMOver *
                (modelData.prixFacture /
                  (modelData.prixMOver * modelData.qte_societe)) *
                  response.data.qte
              ).toFixed(2);

              setPlanTotal(response.data.qte)
              setProductionDepotValeurChainPre(productionDepotValeur)
              console.log("product plan data: " + response.data.qte )
          } catch (error) {
              console.error("Error fetching product plan:", error);
          }
      };

      fetchPlan();
  }, [selectedModel , selectedChain]);


    useEffect(() => {
        const fetchModelByChain = async () => {
            if (selectedChain) {
                try {
                    const response = await api.get(`/getmodelsByChain/${selectedChain}`);
                    fetchChainData(response.data.id)
                    setSelectedModel(response.data.id)
                    const responsed = await api.get(`/chain_production_data/${response.data.id}?chain=${selectedChain}`);
                    const allResponse = await api.get(`/chain_production_data/${response.data.id}`);
                    const alldata = allResponse.data;
                    // Initialize totals
                    let totalSortie = 0;

                    // Calculate totals by iterating through keys
                    Object.keys(alldata).forEach((key) => {
                        const chainData = alldata[key];
                        totalSortie += chainData.latestSortie || 0;
                    });
                    setTotalSortie(totalSortie)

                    const chainData = responsed.data[selectedChain];
                    const sortie = chainData.latestSortie;
                    const modelData = models.find((model) => {
                      return model.id == response.data.id;
                    });
                    const productionDepotValeur = (
                      modelData.prixMOver *
                      (modelData.prixFacture /
                        (modelData.prixMOver * modelData.qte_societe)) *
                        sortie
                    ).toFixed(2);
                    setProductionDepotValeurChain(productionDepotValeur)
                    setSelectedChainSortie(sortie);
                    setModel(response.data);
                } catch (error) {
                    console.error("Error fetching model by chain:", error);
                    setModel(null);
                }
            }
        };

        fetchModelByChain();
    }, [selectedChain]);

    const fetchWorkedHours = async (modelId) => {
        try {
          const response = await api.get(`/production_real_hours/${modelId}`);
          setTotalHours(response.data.worked_hours_count);
        } catch (error) {
          console.error("Error fetching worked hours:", error);
          setError(error.response?.data?.message || "An error occurred");
        }
      };
    
      const fetchChainData = async (modelId) => {
        try {
          setError(null);
            const response = await api.get(`/export/${modelId}`);
            const exportData = response.data;
            setTotalExport(exportData.total);
      
            const modelData = models.find((model) => {
              return model.id == modelId;
            });
      
            const productionDepotValeur = (
              modelData.prixMOver *
              (modelData.prixFacture /
                (modelData.prixMOver * modelData.qte_societe)) *
              exportData.total
            ).toFixed(2);

            console.log(productionDepotValeur)
      
            setProductionDepotValeur(productionDepotValeur);
        } catch (error) {
          console.error(error);
          setError(error.response?.data?.message || "An error occurred");
        }
      };
    
    useEffect(() => {
        const fetchData = async () => {
          try {
            const modelsResponse = await api.get("/models");
            setModels(modelsResponse.data);
    
            const systemResponse = await api.get("/system_constants_latest");
            if (systemResponse.data) {
              const { id, created_at, updated_at, effectif_fix, ...filteredData } =
                systemResponse.data;
              setSystemConstant({
                ...filteredData,
              });
            }
    
            const responseChains = await api.get(`/total_chain`);
            
            if(selectedModel) {
              // Get model-specific effective indirect average during plan period
              try {
                const responseIndirectAverage = await api.get(`/effective_indirect_average/${selectedModel}`);
                if (responseIndirectAverage.data.average_effectif_indirect > 0) {
                  setEffectifInDirect(parseInt(responseIndirectAverage.data.average_effectif_indirect));
                  console.log("📊 Using model-specific effective indirect average:", responseIndirectAverage.data);
                } else {
                  // Fallback to general effective indirect if no model-specific data
                  const responseIndirect = await api.get(`/effective_indirect`);
                  setEffectifInDirect(parseInt(responseIndirect.data.total_effectif_indirect));
                  console.log("⚠️ Using fallback effective indirect:", responseIndirect.data.total_effectif_indirect);
                }
              } catch (error) {
                console.error("Error fetching model-specific effective indirect:", error);
                // Fallback to general effective indirect
                const responseIndirect = await api.get(`/effective_indirect`);
                setEffectifInDirect(parseInt(responseIndirect.data.total_effectif_indirect));
                console.log("⚠️ Using fallback effective indirect due to error:", responseIndirect.data.total_effectif_indirect);
              }
              
              const responseDirect = await api.get(
                `/effective_direct_real/${selectedModel}`
              );
              setEffectifDirect(parseInt(responseDirect.data.total_effectif_direct));

              const responseDirectChainPr = await api.get(`/effective_direct_standard/${selectedModel}/${selectedChain}`)
              setEffectifDirectPr(parseInt(responseDirectChainPr.data.total_effectif_direct))

              const responseDirectChain = await api.get(`/effective_direct_real/${selectedModel}/${selectedChain}`)
              setEffectifDirectChain(parseInt(responseDirectChain.data.total_effectif_direct))
            } else {
              // If no model selected, use general effective indirect
              const responseIndirect = await api.get(`/effective_indirect`);
              setEffectifInDirect(parseInt(responseIndirect.data.total_effectif_indirect));
            }
            
            const responseStandardIndirect = await api.get(`/effective_indirect_total`)
            setEffectifInDirectStandard(
              parseInt(responseStandardIndirect.data.total_effectif_indirect)
            )
            setTotalChains(parseInt(responseChains.data.total_chains));
          } catch (error) {
            console.error("Error fetching data:", error);
          }
        };
    
        fetchData();
      }, [selectedModel]);
    

    const handleChainSelectChange = (e) => {
        const chainId = e.target.value;
        setSelectedChain(chainId);
        setSelectedModel(""); // Reset model selection
        setSelectionType(chainId ? "chain" : "");
        setModel(null); // Reset model data
    };

    const handleModelSelectChange = (e) => {
        const modelId = e.target.value;
        setSelectedModel(modelId);
        setSelectedChain(""); // Reset chain selection
        setSelectionType(modelId ? "model" : "");
        setModel(null); // Reset model data
    };

    const getChainName = (chainId) => {
        const chain = chains.find((chain) => chain.id == chainId);
        return chain ? chain.name : "";
    };

    // Model data fetching function (from MargeNette.js approach)
    const getMargeNetteTotalForModel = async (modelId) => {
        console.log("🏭 === STARTING TOTAL CALCULATION FOR MODEL:", modelId, "===");

        try {
            const chains = await api.get(`/chains`);
            const chainsData = chains.data;

            // Variables to accumulate totals
            let totalProductionValue = 0;
            let totalCostOfProduction = 0;
            let plastiqueValue = 0;
            const modelChainsData = [];

            // Get plastique value once for the model
            const response = await api.get(`/magasin_production/${modelId}`);
            const baseReference = Number(systemConstant.Base_reference_matiere_plastique) || 15000;
            const plasticUnitCost = Number(systemConstant.Coût_plastique_unitaire) || 0;
            plastiqueValue = response.data.value * (plasticUnitCost / baseReference);
            setModelPlastiqueValue(plastiqueValue);
            setModelDepotFinalValue(response.data.value); // Set the depot final value
            console.log("🧵 Plastique Value for model:", plastiqueValue);
            console.log("📦 Depot Final Value for model:", response.data.value);


            // Process each chain
            for (const chain of chainsData) {
                try {
                    const modelResponse = await api.get(`/getmodelsByChain/${chain.id}`);
                    const chainModelId = modelResponse.data.id;
                    
                    if (chainModelId == modelId) {
                        console.log(`🔄 Processing chain ${chain.id} (${chain.name})...`);
                        
                        // Get chain data
                        const chainDataResponse = await api.get(`/chain_production_data/${modelId}`, { 
                            params: { chain: chain.id } 
                        });
                        const chainData = chainDataResponse.data[chain.id];
                        const totalExport = chainData.latestSortie || 0;
                        
                        // Get model data for calculations
                        const modelsResponse = await api.get("/models");
                        const modelData = modelsResponse.data.find((model) => {
                            return model.id == modelId;
                        });

                        if (modelData) {
                            // Use comprehensive chain calculation instead of simplified estimation
                            console.log(`🔄 Calling comprehensive calculation for chain ${chain.id}...`);
                            const result = await calculateMargeNetteForChain(chain.id);
                            
                            modelChainsData.push({
                                chainId: chain.id,
                                chainName: chain.name,
                                productionValue: result.productionValue,
                                costOfProduction: result.costOfProduction,
                                netMargin: result.netMargin,
                                netMarginRate: result.netMarginRate
                            });
                            
                            // Accumulate the values from comprehensive calculation
                            totalProductionValue += result.productionValue;
                            totalCostOfProduction += result.costOfProduction;
                            
                            console.log(`✅ Chain ${chain.id} completed with comprehensive calculation:`, {
                                productionValue: result.productionValue,
                                costOfProduction: result.costOfProduction,
                                netMargin: result.netMargin
                            });
                        }
                    }
                } catch (error) {
                    console.error(`❌ Error processing chain ${chain.id}:`, error);
                    // Continue with other chains
                }
            }

            let clenum = 0;
            let workedHoursByDate = {};
            let totalCostDepot = 0;


            for (const chain of chainsData) {
              try {
                  const modelResponse = await api.get(`/getmodelsByChain/${chain.id}`);
                  const chainModelId = modelResponse.data.id;
                  
                  if (chainModelId == modelId) {
                  console.log("chain.id", chain.id)
                  const cleResponse = await api.get(`/product_plans_cle/${chain.id}`);
                  const workedHoursResponse = await api.get(`/production_real_hours/${modelId}/${chain.id}`);
                  console.log("cleResponse", cleResponse)
                  clenum = cleResponse.data.cle;
                  workedHoursByDate = workedHoursResponse.data.worked_hours_by_date || {};


                              // Calculate depot cost once for the entire model (not per chain)
            console.log("🔍 === CALCULATING DEPOT COST FOR MODEL ===");
            
            // Fetch effective indirect data for the model (similar to MargeNette.js)
            let effectiveIndirectThreeValuesData = {};
            try {
                // Get the first chain that works with this model to fetch the data
                const firstChain = modelChainsData[0];
                if (firstChain) {
                    const effectiveIndirectResponse = await api.get(`/effective_indirect_by_model_chain_day_three_values/${modelId}/${firstChain.chainId}`);
                    effectiveIndirectThreeValuesData = effectiveIndirectResponse.data;
                    console.log("📊 Fetched effective indirect data for model:", effectiveIndirectThreeValuesData);
                }
            } catch (error) {
                console.error("❌ Error fetching effective indirect data for model:", error);
            }
            
            // Calculate depot transport cost for the entire model
            // Use the same approach as mass salary calculation - iterate through effectiveIndirectThreeValuesData directly
            let totalTransportCostEffectiveIndirect = 0;
            console.log('effectiveIndirectThreeValuesData for transport:', effectiveIndirectThreeValuesData);
            console.log('cle' , clenum)
            Object.keys(effectiveIndirectThreeValuesData).forEach(date => {
                const dayData = effectiveIndirectThreeValuesData[date];
                console.log(`📅 ${date} - Day Data:`, dayData);
                
                if (dayData && dayData.effectifIndirects) {
                    const effectifIndirectDay = dayData.effectifIndirects;
                    const QP_effectifDay = effectifIndirectDay * clenum;
                    const Nombre_de_jours_de_production_day = 1;
      
                    const Refacturation_transport_MOD_indirecte = -(
                        (systemConstant.cotisation_entroprise_trans * Nombre_de_jours_de_production_day * QP_effectifDay) / 26
                    );
      
                    const Nombre_unite_utilise = (QP_effectifDay) / systemConstant.Capacité_par_unité_transport;
                    const dailyTransportCost = 2 * Nombre_unite_utilise * Nombre_de_jours_de_production_day * systemConstant.Coût_par_trajet +
                        (Refacturation_transport_MOD_indirecte);
      
                    totalTransportCostEffectiveIndirect += dailyTransportCost;
                    
                    console.log(`📅 ${date} - Transport Cost Calculation:`, {
                        effectifIndirectDay,
                        QP_effectifDay,
                        clenum,
                        Refacturation_transport_MOD_indirecte,
                        Nombre_unite_utilise,
                        dailyTransportCost,
                        runningTotal: totalTransportCostEffectiveIndirect
                    });
                }
            });
      
            console.log("🚚 Step depot - Transport Cost Effective Indirect:", totalTransportCostEffectiveIndirect);
      
            // Calculate depot mass salary for the entire model
            let dayByDayThreeValuesTotal = 0;
            Object.keys(effectiveIndirectThreeValuesData).forEach(date => {
                const dayData = effectiveIndirectThreeValuesData[date];
                const workedHours = workedHoursByDate[date] || 0;
                console.log("workedHours", workedHours)

                if (dayData && dayData.effectifIndirects) {
                    const dayByDayThreeValuesTotald = dayData.effectifIndirects * clenum;
                    dayByDayThreeValuesTotal += dayByDayThreeValuesTotald * workedHours;

                }
            });

            const QP_effectifDepot = dayByDayThreeValuesTotal;
            const congeAnualIndirectDepot = (QP_effectifDepot * systemConstant.Taux_horaire_SMIG_16_29 * 1.5) / 26;
            const masseSalarialeIndirect1629Depot = QP_effectifDepot * systemConstant.Masse_salariale_16_29 * 0.01 * systemConstant.Taux_horaire_SMIG_16_29;
            const masseSalarialeIndirect1700Depot = QP_effectifDepot * systemConstant.Masse_salariale_17_00 * 0.01 * systemConstant.Taux_horaire_17_00;
            const masseSalarialeIndirect1750Depot = QP_effectifDepot * systemConstant.Masse_salariale_17_50 * 0.01 * systemConstant.Taux_horaire_17_50;

            const masseSalarialeInDirecteDepot = 
                masseSalarialeIndirect1700Depot +
                masseSalarialeIndirect1629Depot +
                masseSalarialeIndirect1750Depot +
                congeAnualIndirectDepot;

             totalCostDepot += totalTransportCostEffectiveIndirect + masseSalarialeInDirecteDepot;


                  }
                }
               catch (error) {
                console.error("Error fetching cle:", error);
              }
          };

          console.log("cle", clenum)

            // Calculate final totals
            const modelsResponse = await api.get("/models");
            const modelData = modelsResponse.data.find((model) => {
                return model.id == modelId;
            });

            const productionChainValeur = (
                modelData.prixMOver *
                (modelData.prixFacture /
                    (modelData.prixMOver * modelData.qte_societe)) *
                (response.data.value || 0)
            ).toFixed(2);

            
            console.log("📊 Model Depot Cost Calculation:", {
                totalCostDepot
            });

            // Use the same calculation logic as MargeNette.js chart
            // Add depot costs and plastique costs to match the chart calculation
            const finalCostOfProduction = totalCostOfProduction + totalCostDepot + plastiqueValue;
            let finalNetMargin = parseFloat(productionChainValeur) - finalCostOfProduction;
            if(finalNetMargin > 0) {
                finalNetMargin = finalNetMargin - finalNetMargin * 0.2;
            }

            console.log("🎯 === FINAL CALCULATIONS ===");
            console.log("📊 Accumulated Values:", {
                productionChainValeur,
                totalCostOfProduction,
                totalCostDepot,
                plastiqueValue,
                finalCostOfProduction,
                finalNetMargin
            });

            // Update state
            setModelChains(modelChainsData);
            setModelProductionValue(parseFloat(productionChainValeur));
            setModelTotalCost(parseFloat(finalCostOfProduction));
            setModelNetMargin(parseFloat(finalNetMargin));
            setModelNetMarginRate(parseFloat(productionChainValeur) > 0 ? parseFloat((finalNetMargin / parseFloat(productionChainValeur)) * 100) : 0);

        } catch (error) {
            console.error("❌ Error in getMargeNetteTotalForModel:", error);
            setError(`Failed to calculate total marge nette for model ${modelId}: ${error.message}`);
        }
    };

    // Chain data fetching function (from MargeNetteChainChart.js approach)
    const calculateMargeNetteForChain = async (chainId) => {
        console.log("🚀 === STARTING COMPREHENSIVE CALCULATION FOR CHAIN:", chainId, "===");

        try {
            // Step 1: Get model ID from chain
            const modelResponse = await api.get(`/getmodelsByChain/${chainId}`);
            const modelId = modelResponse.data.id;
            console.log("📋 Step 1 - Model ID:", modelId);
            console.log(`/product_plans_cle/${chainId}`)
            const cleResponseD = await api.get(`/product_plans_cle/${chainId}`);
            const cleD = cleResponseD.data.cle;
            console.log(" cle data", cleD)

            // Step 2: Get all required data in parallel
            const [
                modelsResponse,
                systemResponse,
                chainDataResponse,
                cleResponse,
                workedHoursResponse,
                effectiveDirectResponse,
                effectiveIndirectResponse
            ] = await Promise.all([
                api.get("/models"),
                api.get("/system_constants_latest"),
                api.get(`/chain_production_data/${modelId}`, { params: { chain: chainId } }),
                api.get(`/product_plans_cle/${chainId}`),
                api.get(`/production_real_hours/${modelId}/${chainId}`),
                api.get(`/effective_real_total/${modelId}/${chainId}`),
                api.get(`/effective_indirect_by_model_chain_day/${modelId}/${chainId}`)
            ]);

            console.log("cleResponse", cleResponse.data.cle)

            // Extract data
            const models = modelsResponse.data;
            const systemConstants = systemResponse.data;
            const chainData = chainDataResponse.data[chainId];
            const cle = cleResponse.data.cle;
            const workedHoursByDate = workedHoursResponse.data.worked_hours_by_date || {};
            const effectiveDataByDate = effectiveDirectResponse.data;
            const effectiveIndirectDataByDate = effectiveIndirectResponse.data;

            // Find model data
            const modelData = models.find(model => model.id == modelId);
            if (!modelData) {
                throw new Error(`Model not found for ID: ${modelId}`);
            }

            console.log("📊 Step 2 - Data loaded:", {
                modelData: modelData.modele,
                cle,
                workedHoursDates: Object.keys(workedHoursByDate).length,
                effectiveDirectDates: Object.keys(effectiveDataByDate).length,
                effectiveIndirectDates: Object.keys(effectiveIndirectDataByDate).length
            });

            // Step 3: Calculate Production Value
            const totalExport = chainData.latestSortie || 0;
            const productionValue = (
                modelData.prixMOver *
                (modelData.prixFacture / (modelData.prixMOver * modelData.qte_societe)) *
                totalExport
            ).toFixed(2);

            console.log("💰 Step 3 - Production Value:", {
                totalExport,
                prixMOver: modelData.prixMOver,
                prixFacture: modelData.prixFacture,
                qte_societe: modelData.qte_societe,
                productionValue
            });

            // Step 4: Calculate day-by-day effective direct and indirect
            let totalEffectifDirect = 0;
            let totalEffectifIndirect = 0;
            let totalWorkedHours = 0;

            Object.keys(workedHoursByDate).forEach(date => {
                const workedHours = workedHoursByDate[date] || 0;
                const directData = effectiveDataByDate[date];
                const indirectData = effectiveIndirectDataByDate[date];

                if (workedHours > 0) {
                    totalWorkedHours += workedHours;

                    if (directData && directData.effectifDirects) {
                        totalEffectifDirect += directData.effectifDirects * workedHours;
                    }

                    if (indirectData && indirectData.effectifIndirects) {
                        totalEffectifIndirect += indirectData.effectifIndirects * cle * workedHours;
                    }
                }
            });

            console.log("👥 Step 4 - Effective Calculations:", {
                totalWorkedHours,
                totalEffectifDirect,
                totalEffectifIndirect,
                cle,
                effectiveDataByDate,
                effectiveIndirectDataByDate,
                workedHoursByDate
            });

            // Update state with calculated values
            setCle(cle);
            console.log("cle", cle)
            setWorkedHoursByDate(workedHoursByDate);
            setEffectiveDataByDate(effectiveDataByDate);
            setEffectiveIndirectDataByDate(effectiveIndirectDataByDate);
            setChainTotalHours(totalWorkedHours);
            setChainEffectifDirect(totalEffectifDirect);
            setChainEffectifInDirect(totalEffectifIndirect);
            setChainProductionValue(parseFloat(productionValue));
            setChainTotalExport(totalExport);

            console.log("🧵 Step 5 - Total Export:", totalExport);

            // Calculate comprehensive cost inline (matching MargeNette.js logic)
            console.log("🔍 === COMPREHENSIVE COST CALCULATION ===");
            
            // Step 1: Calculate Mass Salary
            const QP_effectif = totalEffectifIndirect;
            const Nombre_de_jours_de_production = totalWorkedHours / systemConstant.Nombre_d_heures_par_jour;

            // Direct salary calculations
            const congeAnual = (totalEffectifDirect * systemConstant.Taux_horaire_SMIG_16_29 * 1.5) / 26;
            const masseSalariale1629 = totalEffectifDirect * systemConstant.Masse_salariale_16_29 * 0.01 * systemConstant.Taux_horaire_SMIG_16_29;
            const masseSalariale1700 = totalEffectifDirect * systemConstant.Masse_salariale_17_00 * 0.01 * systemConstant.Taux_horaire_17_00;
            const masseSalariale1750 = totalEffectifDirect * systemConstant.Masse_salariale_17_50 * 0.01 * systemConstant.Taux_horaire_17_50;

            // Indirect salary calculations
            const congeAnualIndirect = (QP_effectif * systemConstant.Taux_horaire_SMIG_16_29 * 1.5) / 26;
            const masseSalarialeIndirect1629 = QP_effectif * systemConstant.Masse_salariale_16_29 * 0.01 * systemConstant.Taux_horaire_SMIG_16_29;
            const masseSalarialeIndirect1700 = QP_effectif * systemConstant.Masse_salariale_17_00 * 0.01 * systemConstant.Taux_horaire_17_00;
            const masseSalarialeIndirect1750 = QP_effectif * systemConstant.Masse_salariale_17_50 * 0.01 * systemConstant.Taux_horaire_17_50;

            const masseSalarialeDirecte = masseSalariale1629 + masseSalariale1700 + masseSalariale1750 + congeAnual;
            const masseSalarialeInDirecte = masseSalarialeIndirect1700 + masseSalarialeIndirect1629 + masseSalarialeIndirect1750 + congeAnualIndirect;
            const totalMassSalary = masseSalarialeDirecte + masseSalarialeInDirecte;

            console.log("💵 Mass Salary:", {
                masseSalarialeDirecte,
                masseSalarialeInDirecte,
                totalMassSalary
            });

            // Step 2: Calculate Transport Cost (day-by-day)
            let totalTransportCost = 0;
            Object.keys(workedHoursByDate).forEach(date => {
                const workedHours = workedHoursByDate[date] || 0;
                const directData = effectiveDataByDate[date];
                const indirectData = effectiveIndirectDataByDate[date];

                if (workedHours > 0 && (directData || indirectData)) {
                    const effectifDirectDay = directData ? directData.effectifDirects : 0;
                    const effectifIndirectDay = indirectData ? indirectData.effectifIndirects : 0;
                    const QP_effectifDay = effectifIndirectDay * cle;
                    const Nombre_de_jours_de_production_day = 1;

                    const Refacturation_transport_MOD_indirecte = -(
                        (systemConstant.cotisation_entroprise_trans * Nombre_de_jours_de_production_day * QP_effectifDay) / 26
                    );
                    const Refacturation_transport_MOD_directe = -(
                        (systemConstant.cotisation_entroprise_trans * Nombre_de_jours_de_production_day * effectifDirectDay) / 26
                    );

                    const Nombre_unite_utilise = (QP_effectifDay + effectifDirectDay) / systemConstant.Capacité_par_unité_transport;
                    const dailyTransportCost = 2 * Nombre_unite_utilise * Nombre_de_jours_de_production_day * systemConstant.Coût_par_trajet +
                        (Refacturation_transport_MOD_directe + Refacturation_transport_MOD_indirecte);

                    totalTransportCost += dailyTransportCost;
                }
            });

            console.log("🚚 Transport Cost:", totalTransportCost);

            // Step 3: Calculate Energy and Charges Fixes Costs
            let totalEnergyCost = 0;
            let totalChargesFixesCost = 0;

            Object.keys(workedHoursByDate).forEach(date => {
                const workedHours = workedHoursByDate[date] || 0;
                if (workedHours > 0) {
                    const Nombre_de_jours_de_production_day = workedHours / systemConstant.Nombre_d_heures_par_jour;
                    totalEnergyCost += Nombre_de_jours_de_production_day * systemConstant.Coût_énergie_journalier * cle;
                    totalChargesFixesCost += Nombre_de_jours_de_production_day * systemConstant.Coût_charges_fixes_journalier * cle;
                }
            });

            console.log("⚡ Energy & Charges Fixes:", {
                totalEnergyCost,
                totalChargesFixesCost
            });

            // Step 4: Calculate Fil/Plastic Costs
            const baseReferenceFil = Number(systemConstant.Base_reference_matiere_fil) || 20000;
            const filUnitCost = Number(systemConstant.Coût_fil_unitaire) || 20000;
            const filCost = totalExport * (filUnitCost / baseReferenceFil);
            console.log("🧵 Fil/Plastic Cost:", filCost);

            // Step 5: Calculate Total Cost
            const totalCost = totalMassSalary + totalTransportCost + totalChargesFixesCost + totalEnergyCost + filCost;

            console.log("🧮 Total Cost Breakdown:", {
                totalMassSalary,
                totalTransportCost,
                totalChargesFixesCost,
                totalEnergyCost,
                filCost,
                totalCost
            });

            // Step 6: Calculate Margins
            const margeBrute = parseFloat(productionValue) - totalCost;
            const margeNette = margeBrute > 0 ? margeBrute - margeBrute * 0.2 : margeBrute;
            const finalNetMarginRate = parseFloat(productionValue) > 0 ? (margeNette / parseFloat(productionValue)) * 100 : 0;

            console.log("📈 Margins:", {
                productionValue: parseFloat(productionValue),
                totalCost,
                margeBrute,
                margeNette
            });

            const result = {
                productionValue: parseFloat(productionValue),
                costOfProduction: parseFloat(totalCost.toFixed(2)),
                netMargin: parseFloat(margeNette.toFixed(2)),
                netMarginRate: parseFloat(finalNetMarginRate.toFixed(2)),
                totalExport: parseFloat(totalExport)
            };

            console.log("✅ === COMPREHENSIVE CALCULATION COMPLETED ===");
            console.log("📊 Returning result:", result);

            return result;

        } catch (error) {
            console.error("❌ Error in calculateMargeNetteForChain:", error);
            throw new Error(`Failed to calculate marge nette for chain ${chainId}: ${error.message}`);
        }
    };

    // Depot-specific calculation functions (from MargeNette.js approach)
    const calculateModelDepotTransportCost = () => {
        console.log("🔍 === MODEL DEPOT CALCULATION: Transport Cost ===");
        
        if (!workedHoursByDate || !effectiveIndirectDataByDate || !cle) {
            console.log("Missing required data for depot transport calculation");
            return;
        }

        let totalTransportCostEffectiveIndirect = 0;
        
        Object.keys(effectiveIndirectDataByDate).forEach(date => {
            const dayData = effectiveIndirectDataByDate[date];
            const workedHours = workedHoursByDate[date] || 0;
            
            if (dayData && dayData.effectifIndirects) {
                let dayCalculation = dayData.effectifIndirects * cle;
                dayCalculation = dayCalculation * workedHours;
                totalTransportCostEffectiveIndirect += dayCalculation;
            }
        });

        setModelDepotTransportCost(parseFloat(totalTransportCostEffectiveIndirect));
        console.log("✅ Model Depot Transport Cost:", totalTransportCostEffectiveIndirect);
        console.log("🔍 === END MODEL DEPOT CALCULATION ===");
    };

    const calculateModelDepotMassSalary = () => {
        console.log("🔍 === MODEL DEPOT CALCULATION: Mass Salary ===");
        
        if (!workedHoursByDate || !effectiveIndirectDataByDate || !systemConstant) {
            console.log("Missing required data for depot mass salary calculation");
            return;
        }

        const {
            Taux_horaire_SMIG_16_29,
            Taux_horaire_17_00,
            Taux_horaire_17_50,
            Masse_salariale_16_29,
            Masse_salariale_17_00,
            Masse_salariale_17_50,
            Nombre_d_heures_par_jour
        } = systemConstant;

        // Calculate QP_effectifDepot (total indirect effectif for depot)
        let dayByDayThreeValuesTotal = 0;
        Object.keys(effectiveIndirectDataByDate).forEach(date => {
            const dayData = effectiveIndirectDataByDate[date];
            if (dayData && dayData.effectifIndirects) {
                dayByDayThreeValuesTotal += dayData.effectifIndirects;
            }
        });

        const QP_effectifDepot = dayByDayThreeValuesTotal;
        console.log("QP_effectifDepot", QP_effectifDepot);

        const congeAnualIndirectDepot = (QP_effectifDepot * Taux_horaire_SMIG_16_29 * 1.5) / 26;
        console.log("congeAnualIndirectDepot", congeAnualIndirectDepot);

        const masseSalarialeIndirect1629Depot = QP_effectifDepot * Masse_salariale_16_29 * 0.01 * Taux_horaire_SMIG_16_29;
        console.log("masseSalarialeIndirect1629Depot", masseSalarialeIndirect1629Depot);

        const masseSalarialeIndirect1700Depot = QP_effectifDepot * Masse_salariale_17_00 * 0.01 * Taux_horaire_17_00;
        const masseSalarialeIndirect1750Depot = QP_effectifDepot * Masse_salariale_17_50 * 0.01 * Taux_horaire_17_50;

        const masseSalarialeInDirecteDepot = 
            masseSalarialeIndirect1700Depot +
            masseSalarialeIndirect1629Depot +
            masseSalarialeIndirect1750Depot +
            congeAnualIndirectDepot;

        setModelDepotMassSalary(parseFloat(masseSalarialeInDirecteDepot));
        console.log("💵 Model Depot Mass Salary:", {
            masseSalarialeInDirecteDepot,
            masseSalarialeIndirect1700Depot,
            masseSalarialeIndirect1629Depot,
            masseSalarialeIndirect1750Depot,
            congeAnualIndirectDepot
        });
        console.log("🔍 === END MODEL DEPOT CALCULATION ===");
    };

    const calculateModelDepotTotalCost = () => {
        console.log("🔍 === MODEL DEPOT CALCULATION: Total Cost ===");
        
        const totalCostDepot = modelDepotTransportCost + modelDepotMassSalary;
        setModelDepotTotalCost(parseFloat(totalCostDepot));
        
        console.log("🔍 Model Depot Total Cost:", totalCostDepot);
        console.log("🔍 === END MODEL DEPOT CALCULATION ===");
    };

    // Chain-specific calculation functions (from MargeNetteChainChart.js approach)
    const calculateChainTotalMasseSalariale = () => {
        const {
            Taux_horaire_SMIG_16_29,
            Taux_horaire_17_00,
            Taux_horaire_17_50,
            Masse_salariale_16_29,
            Masse_salariale_17_00,
            Masse_salariale_17_50,
        } = systemConstant;

        console.log("🔍 === CHAIN MASS SALARY CALCULATION ===");
        console.log("📊 Input Values:");
        console.log("  - chainTotalHours:", chainTotalHours);
        console.log("  - chainEffectifDirect:", chainEffectifDirect);
        console.log("  - chainEffectifInDirect:", chainEffectifInDirect);

        // Since chainEffectifDirect and chainEffectifInDirect are already day-by-day calculated (person-hours),
        // we need to use them directly with hourly rates, not multiply by hours again
        
        const congeAnual =
            (chainEffectifDirect * Taux_horaire_SMIG_16_29 * 1.5) / 26;

        const masseSalariale1629 =
            chainEffectifDirect *
            Masse_salariale_16_29 *
            0.01 *
            Taux_horaire_SMIG_16_29;

        const masseSalariale1700 =
            chainEffectifDirect *
            Masse_salariale_17_00 *
            0.01 *
            Taux_horaire_17_00;

        const masseSalariale1750 =
            chainEffectifDirect *
            Masse_salariale_17_50 *
            0.01 *
            Taux_horaire_17_50;

        const QP_effectif = chainEffectifInDirect;

        const congeAnualIndirect =
            (QP_effectif * Taux_horaire_SMIG_16_29 * 1.5) / 26;

        const masseSalarialeIndirect1629 =
            QP_effectif *
            Masse_salariale_16_29 *
            0.01 *
            Taux_horaire_SMIG_16_29;

        const masseSalarialeIndirect1700 =
            QP_effectif *
            Masse_salariale_17_00 *
            0.01 *
            Taux_horaire_17_00;

        const masseSalarialeIndirect1750 =
            QP_effectif *
            Masse_salariale_17_50 *
            0.01 *
            Taux_horaire_17_50;

        const masseSalarialeDirecte =
            masseSalariale1629 + masseSalariale1700 + masseSalariale1750 + congeAnual;

        const masseSalarialeInDirecte =
            masseSalarialeIndirect1700 +
            masseSalarialeIndirect1629 +
            masseSalarialeIndirect1750 +
            congeAnualIndirect;

        const totalSalary = masseSalarialeDirecte + masseSalarialeInDirecte;

        console.log("🧮 Final Mass Salary Results:");
        console.log("  - masseSalarialeDirecte:", masseSalarialeDirecte);
        console.log("  - masseSalarialeInDirecte:", masseSalarialeInDirecte);
        console.log("  - Total Mass Salary:", totalSalary);
        console.log("  - Breakdown:");
        console.log("    - congeAnual:", congeAnual);
        console.log("    - masseSalariale1629:", masseSalariale1629);
        console.log("    - masseSalariale1700:", masseSalariale1700);
        console.log("    - masseSalariale1750:", masseSalariale1750);
        console.log("    - congeAnualIndirect:", congeAnualIndirect);
        console.log("    - masseSalarialeIndirect1629:", masseSalarialeIndirect1629);
        console.log("    - masseSalarialeIndirect1700:", masseSalarialeIndirect1700);
        console.log("    - masseSalarialeIndirect1750:", masseSalarialeIndirect1750);
        console.log("🔍 === END CHAIN MASS SALARY CALCULATION ===");

        setChainTotalMassSalary(parseFloat(totalSalary.toFixed(4)));
    };

    const calculateChainCouteTransport = () => {
        const {
            Nombre_d_heures_par_jour,
            Capacité_par_unité_transport,
            Coût_par_trajet,
            cotisation_entroprise_trans,
        } = systemConstant;

        let totalTransportCost = 0;
        const dailyTransportCosts = {};

        console.log("🔍 === CHAIN DAY-BY-DAY TRANSPORT COST CALCULATION ===");
        console.log("📊 Effective Direct Data:", effectiveDataByDate);
        console.log("📊 Effective Indirect Data:", effectiveIndirectDataByDate);
        console.log("📊 Worked Hours Data:", workedHoursByDate);

        // Loop through all dates that have worked hours
        Object.keys(workedHoursByDate).forEach(date => {
            const workedHours = workedHoursByDate[date] || 0;
            const directData = effectiveDataByDate[date];
            const indirectData = effectiveIndirectDataByDate[date];

            if (workedHours > 0 && (directData || indirectData)) {
                // Get effective direct for this day
                const effectifDirectDay = directData ? directData.effectifDirects : 0;
                
                // Get effective indirect for this day
                const effectifIndirectDay = indirectData ? indirectData.effectifIndirects : 0;
                
                // Calculate QP_effectif for this day
                const QP_effectif = effectifIndirectDay * cle;

                // Calculate days of production for this day (1 day)
                const Nombre_de_jours_de_production = 1;

                // Calculate refacturation for this day
                const Refacturation_transport_MOD_indirecte = -(
                    (cotisation_entroprise_trans *
                        Nombre_de_jours_de_production *
                        QP_effectif) /
                    26
                );

                const Refacturation_transport_MOD_directe = -(
                    (cotisation_entroprise_trans *
                        Nombre_de_jours_de_production *
                        effectifDirectDay) /
                    26
                );

                // Calculate number of units used for this day
                const Nombre_unite_utilise =
                    (QP_effectif + effectifDirectDay) / Capacité_par_unité_transport;

                // Calculate transport cost for this day
                const dailyTransportCost =
                    2 *
                    Nombre_unite_utilise *
                    Nombre_de_jours_de_production *
                    Coût_par_trajet +
                    (Refacturation_transport_MOD_directe +
                        Refacturation_transport_MOD_indirecte);

                dailyTransportCosts[date] = dailyTransportCost;
                totalTransportCost += dailyTransportCost;

                console.log(`📅 ${date}:`, {
                    workedHours,
                    effectifDirectDay,
                    effectifIndirectDay,
                    QP_effectif,
                    cle,
                    Refacturation_transport_MOD_indirecte,
                    Refacturation_transport_MOD_directe,
                    Nombre_unite_utilise,
                    Nombre_de_jours_de_production,
                    Coût_par_trajet,
                    cotisation_entroprise_trans,
                    dailyTransportCost,
                    runningTotal: totalTransportCost
                });
            }
        });

        console.log("🧮 Final Total Transport Cost (Day-by-Day):", totalTransportCost);
        console.log("📊 Daily Transport Costs:", dailyTransportCosts);
        console.log("🔍 === END CHAIN DAY-BY-DAY TRANSPORT COST CALCULATION ===");

        setChainCouteTransport(parseFloat(totalTransportCost.toFixed(4)));
    };

    const calculateChainCoûtEnergie = () => {
        const { Coût_énergie_journalier, Nombre_d_heures_par_jour } = systemConstant;
        
        let totalEnergyCost = 0;
        const dailyEnergyCosts = {};

        console.log("🔍 === CHAIN DAY-BY-DAY ENERGY COST CALCULATION ===");
        console.log("📊 Worked Hours Data:", workedHoursByDate);
        console.log("📊 Coût_énergie_journalier:", Coût_énergie_journalier);
        console.log("📊 Nombre_d_heures_par_jour:", Nombre_d_heures_par_jour);

        // Loop through all dates that have worked hours
        Object.keys(workedHoursByDate).forEach(date => {
            const workedHours = workedHoursByDate[date] || 0;
            
            if (workedHours > 0) {
                // Calculate days of production for this day based on worked hours
                const Nombre_de_jours_de_production = workedHours / Nombre_d_heures_par_jour;
                
                // Calculate energy cost for this day
                const dailyEnergyCost = Nombre_de_jours_de_production * Coût_énergie_journalier * cle;
                
                dailyEnergyCosts[date] = dailyEnergyCost;
                totalEnergyCost += dailyEnergyCost;

                console.log(`📅 ${date}:`, {
                    workedHours,
                    Nombre_de_jours_de_production,
                    Coût_énergie_journalier,
                    dailyEnergyCost,
                    runningTotal: totalEnergyCost
                });
            }
        });

        console.log("🧮 Final Total Energy Cost (Day-by-Day):", totalEnergyCost);
        console.log("📊 Daily Energy Costs:", dailyEnergyCosts);
        console.log("🔍 === END CHAIN DAY-BY-DAY ENERGY COST CALCULATION ===");
        
        setChainCoûtEnergie(parseFloat(totalEnergyCost));
    };

    const calculateChainCoûtChargesFixes = () => {
        const { Coût_charges_fixes_journalier, Nombre_d_heures_par_jour } = systemConstant;
        
        let totalChargesFixesCost = 0;
        const dailyChargesFixesCosts = {};

        console.log("🔍 === CHAIN DAY-BY-DAY CHARGES FIXES COST CALCULATION ===");
        console.log("📊 Worked Hours Data:", workedHoursByDate);
        console.log("📊 Coût_charges_fixes_journalier:", Coût_charges_fixes_journalier);
        console.log("📊 Nombre_d_heures_par_jour:", Nombre_d_heures_par_jour);

        // Loop through all dates that have worked hours
        Object.keys(workedHoursByDate).forEach(date => {
            const workedHours = workedHoursByDate[date] || 0;
            
            if (workedHours > 0) {
                // Calculate days of production for this day based on worked hours
                const Nombre_de_jours_de_production = workedHours / Nombre_d_heures_par_jour;
                
                // Calculate charges fixes cost for this day
                const dailyChargesFixesCost = Nombre_de_jours_de_production * Coût_charges_fixes_journalier * cle;
                
                dailyChargesFixesCosts[date] = dailyChargesFixesCost;
                totalChargesFixesCost += dailyChargesFixesCost;

                console.log(`📅 ${date}:`, {
                    workedHours,
                    Nombre_de_jours_de_production,
                    Coût_charges_fixes_journalier,
                    dailyChargesFixesCost,
                    runningTotal: totalChargesFixesCost
                });
            }
        });

        console.log("🧮 Final Total Charges Fixes Cost (Day-by-Day):", totalChargesFixesCost);
        console.log("📊 Daily Charges Fixes Costs:", dailyChargesFixesCosts);
        console.log("🔍 === END CHAIN DAY-BY-DAY CHARGES FIXES COST CALCULATION ===");
        
        setChainCoûtChargesFixes(parseFloat(totalChargesFixesCost));
    };

    const calculateChainCouteFil = () => {
        if (!chainTotalExport || chainTotalExport <= 0) {
            console.log("No chainTotalExport available, skipping fil calculation");
            return;
        }

        console.log("🔍 === CHAIN CALCULATION: Fil TOTAL pour la chaîne ===");
        console.log("📊 Input Data:");
        console.log("  - chainTotalExport:", chainTotalExport);
        
        const baseReferenceFil = Number(systemConstant.Base_reference_matiere_fil) || 20000;
        const filUnitCost = Number(systemConstant.Coût_fil_unitaire) || 20000;
        const filCost = chainTotalExport * (filUnitCost / baseReferenceFil);

        setChainFilsParChain(parseFloat(filCost));

        console.log("✅ Using correct calculation from system constants:", {
            chainTotalExport,
            filCost,
            formula: `${chainTotalExport} * (${filUnitCost} / ${baseReferenceFil}) = ${filCost}`
        });
        
        console.log("🔍 === END CHAIN CALCULATION ===");
    };

    const calculateChainCoûtDeRevient = () => {
        const filCost = chainFilsParChain;
        
        const totalCost =
            parseFloat(chainTotalMassSalary) +
            parseFloat(chainCouteTransport) +
            parseFloat(chainCoûtChargesFixes) +
            parseFloat(chainCoûtEnergie) +
            parseFloat(filCost);

        console.log("🔍 === CHAIN CALCULATION: Coût de revient ===");
        console.log("📊 Input Data:");
        console.log("  - chainTotalMassSalary:", parseFloat(chainTotalMassSalary));
        console.log("  - chainCouteTransport:", parseFloat(chainCouteTransport));
        console.log("  - chainCoûtChargesFixes:", parseFloat(chainCoûtChargesFixes));
        console.log("  - chainCoûtEnergie:", parseFloat(chainCoûtEnergie));
        console.log("  - filCost:", parseFloat(filCost));
        console.log("🧮 Total Cost:", totalCost);
        console.log("🧮 Cost Breakdown:");
        console.log("  - Mass Salary:", parseFloat(chainTotalMassSalary));
        console.log("  - Transport:", parseFloat(chainCouteTransport));
        console.log("  - Fixed Charges:", parseFloat(chainCoûtChargesFixes));
        console.log("  - Energy:", parseFloat(chainCoûtEnergie));
        console.log("  - Fil/Plastic:", parseFloat(filCost));
        console.log("🔍 === END CHAIN CALCULATION ===");

        setChainTotalCost(parseFloat(totalCost.toFixed(2)));
        return totalCost;
    };

    const calculateCouteTransport = () => {
        const QP_effectif = effectifInDirect / totalChains;
        // 8.92
        const {
          Nombre_d_heures_par_jour,
          Capacité_par_unité_transport,
          Coût_par_trajet,
          cotisation_entroprise_trans,
        } = systemConstant;
    
        const Nombre_de_jours_de_production = totalHours / Nombre_d_heures_par_jour;
    // 0.33
        const Refacturation_transport_MOD_indirecte = -(
          (cotisation_entroprise_trans *
            Nombre_de_jours_de_production *
            QP_effectif) /
          26
        );

        // -9.05
    
        const Refacturation_transport_MOD_directe = -(
          (cotisation_entroprise_trans *
            Nombre_de_jours_de_production *
            effectifDirect) /
          26
        );

        // -10.15
    
        const Nombre_unite_utilise =
          (QP_effectif + effectifDirect) / Capacité_par_unité_transport;
    // 0.946
        const transportCost =
          2 *
            Nombre_unite_utilise *
            Nombre_de_jours_de_production *
            Coût_par_trajet +
          (Refacturation_transport_MOD_directe +
            Refacturation_transport_MOD_indirecte);
    
        setCouteTransport(transportCost.toFixed(4));
    };

    const calculateCouteTransportParChain = () => {
      const QP_effectif = effectifInDirect / totalChains;
      const {
        Nombre_d_heures_par_jour,
        Capacité_par_unité_transport,
        Coût_par_trajet,
        cotisation_entroprise_trans,
      } = systemConstant;
  
      const Nombre_de_jours_de_production = totalHours / Nombre_d_heures_par_jour;
  
      const Refacturation_transport_MOD_indirecte = -(
        (cotisation_entroprise_trans *
          Nombre_de_jours_de_production *
          QP_effectif) /
        26
      );
  
      const Refacturation_transport_MOD_directe = -(
        (cotisation_entroprise_trans *
          Nombre_de_jours_de_production *
          effectifDirectChain) /
        26
      );
  
      const Nombre_unite_utilise =
        (QP_effectif + effectifDirectChain) / Capacité_par_unité_transport;
  
      const transportCost =
        2 *
          Nombre_unite_utilise *
          Nombre_de_jours_de_production *
          Coût_par_trajet +
        (Refacturation_transport_MOD_directe +
          Refacturation_transport_MOD_indirecte);
  
      console.log("🔍 === CALCULATION: Transport Cost per Chain ===");
      console.log("📊 Input Data:");
      console.log("  - QP_effectif:", QP_effectif);
      console.log("  - effectifDirectChain:", effectifDirectChain);
      console.log("  - totalHours:", totalHours);
      console.log("  - totalChains:", totalChains);
      console.log("  - System Constants:", {
        Nombre_d_heures_par_jour: Nombre_d_heures_par_jour,
        Capacité_par_unité_transport: Capacité_par_unité_transport,
        Coût_par_trajet: Coût_par_trajet,
        cotisation_entroprise_trans: cotisation_entroprise_trans,
      });
      
      console.log("🧮 Transport Calculations:");
      console.log(`  - Production days: ${Nombre_de_jours_de_production}`);
      console.log(`  - Refacturation transport MOD indirecte: ${Refacturation_transport_MOD_indirecte}`);
      console.log(`  - Refacturation transport MOD directe: ${Refacturation_transport_MOD_directe}`);
      console.log(`  - Number of units used: ${Nombre_unite_utilise}`);
      console.log(`  - Transport cost: ${transportCost}`);
      
      setCouteTransportParChain(transportCost.toFixed(4));
      console.log("🔍 === END CALCULATION ===");

    }

    const calculateCouteTransportParChainPre = () => {
      const QP_effectif = effectifInDirectStandard / totalChains;
      const {
        Nombre_d_heures_par_jour,
        Capacité_par_unité_transport,
        Coût_par_trajet,
        cotisation_entroprise_trans,
      } = systemConstant;
  
      const Nombre_de_jours_de_production = totalHours / Nombre_d_heures_par_jour;
  
      const Refacturation_transport_MOD_indirecte = -(
        (cotisation_entroprise_trans *
          Nombre_de_jours_de_production *
          QP_effectif) /
        26
      );
  
      const Refacturation_transport_MOD_directe = -(
        (cotisation_entroprise_trans *
          Nombre_de_jours_de_production *
          effectifDirectPr) /
        26
      );
  
      const Nombre_unite_utilise =
        (QP_effectif + effectifDirectPr) / Capacité_par_unité_transport;
  
      const transportCost =
        2 *
          Nombre_unite_utilise *
          Nombre_de_jours_de_production *
          Coût_par_trajet +
        (Refacturation_transport_MOD_directe +
          Refacturation_transport_MOD_indirecte);
  
      setCouteTransportParChainPre(transportCost.toFixed(4));

    }

    
    const calculateTotalMasseSalariale = () => {
        const {
          Taux_horaire_SMIG_16_29,
          Taux_horaire_17_00,
          Taux_horaire_17_50,
          Masse_salariale_16_29,
          Masse_salariale_17_00,
          Masse_salariale_17_50,
        } = systemConstant;
    
        const congeAnual =
          (totalHours * effectifDirect * Taux_horaire_SMIG_16_29 * 1.5) / 26;
          // 34.14
    
        const masseSalariale1629 =
          totalHours *
          effectifDirect *
          Masse_salariale_16_29 *
          0.01 *
          Taux_horaire_SMIG_16_29;
          // 355.14
    
        const masseSalariale1700 =
          totalHours *
          effectifDirect *
          Masse_salariale_17_00 *
          0.01 *
          Taux_horaire_17_00;
          // 185.31
    
        const masseSalariale1750 =
          totalHours *
          effectifDirect *
          Masse_salariale_17_50 *
          0.01 *
          Taux_horaire_17_50;
          // 63.57
    
        const QP_effectif = effectifInDirect / totalChains;
    // 8.92
        const congeAnualIndirect =
          (totalHours * QP_effectif * Taux_horaire_SMIG_16_29 * 1.5) / 26;
    // 30.44
        const masseSalarialeIndirect1629 =
          totalHours *
          QP_effectif *
          Masse_salariale_16_29 *
          0.01 *
          Taux_horaire_SMIG_16_29;
    //  316.78
        const masseSalarialeIndirect1700 =
          totalHours *
          QP_effectif *
          Masse_salariale_17_00 *
          0.01 *
          Taux_horaire_17_00;
    // 165.30
        const masseSalarialeIndirect1750 =
          totalHours *
          QP_effectif *
          Masse_salariale_17_50 *
          0.01 *
          Taux_horaire_17_50;
    // 56.70
        const masseSalarialeDirecte =
          masseSalariale1629 + masseSalariale1700 + masseSalariale1750 + congeAnual;
    
        const masseSalarialeInDirecte =
          masseSalarialeIndirect1700 +
          masseSalarialeIndirect1629 +
          masseSalarialeIndirect1750 +
          congeAnualIndirect;
    
        setTotalMassSalary(
          (masseSalarialeInDirecte + masseSalarialeDirecte).toFixed(4)
        );
    };

    const calculateTotalMasseSalarialeParChain = () => {
        const {
          Taux_horaire_SMIG_16_29,
          Taux_horaire_17_00,
          Taux_horaire_17_50,
          Masse_salariale_16_29,
          Masse_salariale_17_00,
          Masse_salariale_17_50,
        } = systemConstant;
    
        const congeAnual =
          (totalHours * effectifDirectChain * Taux_horaire_SMIG_16_29 * 1.5) / 26;
    
        const masseSalariale1629 =
          totalHours *
          effectifDirectChain *
          Masse_salariale_16_29 *
          0.01 *
          Taux_horaire_SMIG_16_29;
    
        const masseSalariale1700 =
          totalHours *
          effectifDirectChain *
          Masse_salariale_17_00 *
          0.01 *
          Taux_horaire_17_00;
    
        const masseSalariale1750 =
          totalHours *
          effectifDirectChain *
          Masse_salariale_17_50 *
          0.01 *
          Taux_horaire_17_50;
    
        const QP_effectif = effectifInDirect / totalChains;
    
        const congeAnualIndirect =
          (totalHours * QP_effectif * Taux_horaire_SMIG_16_29 * 1.5) / 26;
    
        const masseSalarialeIndirect1629 =
          totalHours *
          QP_effectif *
          Masse_salariale_16_29 *
          0.01 *
          Taux_horaire_SMIG_16_29;
    
        const masseSalarialeIndirect1700 =
          totalHours *
          QP_effectif *
          Masse_salariale_17_00 *
          0.01 *
          Taux_horaire_17_00;
    
        const masseSalarialeIndirect1750 =
          totalHours *
          QP_effectif *
          Masse_salariale_17_50 *
          0.01 *
          Taux_horaire_17_50;
    
        const masseSalarialeDirecte =
          masseSalariale1629 + masseSalariale1700 + masseSalariale1750 + congeAnual;
    
        const masseSalarialeInDirecte =
          masseSalarialeIndirect1700 +
          masseSalarialeIndirect1629 +
          masseSalarialeIndirect1750 +
          congeAnualIndirect;
    
        const totalSalary = masseSalarialeInDirecte + masseSalarialeDirecte;
        
        console.log("🔍 === CALCULATION: Total Masse Salariale par chaine ===");
        console.log("📊 Input Data:");
        console.log("  - totalHours:", totalHours);
        console.log("  - effectifDirectChain:", effectifDirectChain);
        console.log("  - effectifInDirect:", effectifInDirect);
        console.log("  - totalChains:", totalChains);
        console.log("  - System Constants:", {
          Taux_horaire_SMIG_16_29: Taux_horaire_SMIG_16_29,
          Taux_horaire_17_00: Taux_horaire_17_00,
          Taux_horaire_17_50: Taux_horaire_17_50,
          Masse_salariale_16_29: Masse_salariale_16_29,
          Masse_salariale_17_00: Masse_salariale_17_00,
          Masse_salariale_17_50: Masse_salariale_17_50,
        });
        
        console.log("🧮 Direct Salary Calculations:");
        console.log(`  - Annual leave: ${congeAnual}`);
        console.log(`  - SMIG 16-29: ${masseSalariale1629}`);
        console.log(`  - SMIG 17-00: ${masseSalariale1700}`);
        console.log(`  - SMIG 17-50: ${masseSalariale1750}`);
        console.log(`  - Total Direct: ${masseSalarialeDirecte}`);
        
        console.log("🧮 Indirect Salary Calculations:");
        console.log(`  - QP effectif per chain: ${QP_effectif}`);
        console.log(`  - Annual leave indirect: ${congeAnualIndirect}`);
        console.log(`  - SMIG 16-29 indirect: ${masseSalarialeIndirect1629}`);
        console.log(`  - SMIG 17-00 indirect: ${masseSalarialeIndirect1700}`);
        console.log(`  - SMIG 17-50 indirect: ${masseSalarialeIndirect1750}`);
        console.log(`  - Total Indirect: ${masseSalarialeInDirecte}`);
        
        console.log(`💰 Total Salary per Chain: ${totalSalary}`);
        
        setTotalMassSalaryParChain(totalSalary.toFixed(4));
        console.log("🔍 === END CALCULATION ===");
    };

    const calculateTotalMasseSalarialeParChainPre = () => {
      const {
        Taux_horaire_SMIG_16_29,
        Taux_horaire_17_00,
        Taux_horaire_17_50,
        Masse_salariale_16_29,
        Masse_salariale_17_00,
        Masse_salariale_17_50,
      } = systemConstant;
  
      const congeAnual =
        (totalHours * effectifDirectPr * Taux_horaire_SMIG_16_29 * 1.5) / 26;
  
      const masseSalariale1629 =
        totalHours *
        effectifDirectPr *
        Masse_salariale_16_29 *
        0.01 *
        Taux_horaire_SMIG_16_29;
  
      const masseSalariale1700 =
        totalHours *
        effectifDirectPr *
        Masse_salariale_17_00 *
        0.01 *
        Taux_horaire_17_00;
  
      const masseSalariale1750 =
        totalHours *
        effectifDirectPr *
        Masse_salariale_17_50 *
        0.01 *
        Taux_horaire_17_50;
  
      const QP_effectif = effectifInDirectStandard / totalChains;
  
      const congeAnualIndirect =
        (totalHours * QP_effectif * Taux_horaire_SMIG_16_29 * 1.5) / 26;
  
      const masseSalarialeIndirect1629 =
        totalHours *
        QP_effectif *
        Masse_salariale_16_29 *
        0.01 *
        Taux_horaire_SMIG_16_29;
  
      const masseSalarialeIndirect1700 =
        totalHours *
        QP_effectif *
        Masse_salariale_17_00 *
        0.01 *
        Taux_horaire_17_00;
  
      const masseSalarialeIndirect1750 =
        totalHours *
        QP_effectif *
        Masse_salariale_17_50 *
        0.01 *
        Taux_horaire_17_50;
  
      const masseSalarialeDirecte =
        masseSalariale1629 + masseSalariale1700 + masseSalariale1750 + congeAnual;
  
      const masseSalarialeInDirecte =
        masseSalarialeIndirect1700 +
        masseSalarialeIndirect1629 +
        masseSalarialeIndirect1750 +
        congeAnualIndirect;
  
      setTotalMassSalaryParChain(
        (masseSalarialeInDirecte + masseSalarialeDirecte).toFixed(4)
      );

    }
    
    const calculateCouteFilAndPlastique = async () => {
      if (!selectedModel) return;
      
      console.log("🔍 === CALCULATION: Fil et Plastique par chaine ===");
      console.log("📊 Input Data:");
      console.log("  - selectedModel:", selectedModel);
      console.log("  - selectedChain:", selectedChain);
      console.log("  - totalExport:", totalExport);
      console.log("  - totalChains:", totalChains);
      
      try {
        const response = await api.get(`/plastique_fil_per_chain/${selectedModel}`);
        const data = response.data;
        console.log("📡 API Response:", data);
        
        if (data.hasRealData && data.perChainDistribution.length > 0) {
          console.log("✅ Using REAL data from backend");
          // Use real data from backend for per-chain distribution
          const selectedChainData = data.perChainDistribution.find(
            chain => chain.chain_id == selectedChain
          );
          console.log("🔍 Selected Chain Data:", selectedChainData);
          
          if (selectedChainData) {
            // Use real data for the selected chain
            const filCost = selectedChainData.filCost || 0;
            const otherCost = selectedChainData.otherCost || 0;
            const plastiqueCost = selectedChainData.plastiqueCost || 0;
            
            setFils(filCost + otherCost);
            setFilsParChain(filCost);
            setPlastique(plastiqueCost + otherCost);
            setPlastiqueParChain(plastiqueCost);
            
            console.log("💰 Real Data Results:");
            console.log(`  - Fil cost per chain: ${filCost}`);
            console.log(`  - Plastic cost per chain: ${plastiqueCost}`);
            console.log(`  - Other cost: ${otherCost}`);
          } else {
            console.log("⚠️ No data found for selected chain, using fallback");
            const baseReferenceFil = Number(systemConstant.Base_reference_matiere_fil) || 20000;
            const baseReferencePlastique = Number(systemConstant.Base_reference_matiere_plastique) || 15000;
            const filUnitCost = Number(systemConstant.Coût_fil_unitaire) || 20000;
            const plasticUnitCost = Number(systemConstant.Coût_plastique_unitaire) || 15000;
            const filCost = totalExport * (filUnitCost / baseReferenceFil);
            const plastiqueCost = totalExport * (plasticUnitCost / baseReferencePlastique);

            setFils(filCost);
            setFilsParChain(filCost);
            setPlastique(plastiqueCost);
            setPlastiqueParChain(plastiqueCost);
            
            console.log("💰 Fallback Calculation Results:");
            console.log(`  - Fil cost per chain: ${filCost}`);
            console.log(`  - Plastic cost per chain: ${plastiqueCost}`);
          }
        } else {
          console.log("⚠️ No real data available, using fallback calculation");
          const baseReferenceFil = Number(systemConstant.Base_reference_matiere_fil) || 20000;
          const baseReferencePlastique = Number(systemConstant.Base_reference_matiere_plastique) || 15000;
          const filUnitCost = Number(systemConstant.Coût_fil_unitaire) || 20000;
          const plasticUnitCost = Number(systemConstant.Coût_plastique_unitaire) || 15000;
          const filCost = totalExport * (filUnitCost / baseReferenceFil);
          const plastiqueCost = totalExport * (plasticUnitCost / baseReferencePlastique);

          setFils(filCost);
          setFilsParChain(filCost);
          setPlastique(plastiqueCost);
          setPlastiqueParChain(plastiqueCost);
          
          console.log("💰 Fallback Calculation Results:");
          console.log(`  - Fil cost per chain: ${filCost}`);
          console.log(`  - Plastic cost per chain: ${plastiqueCost}`);
        }
      } catch (error) {
        console.error("❌ Error fetching real plastique/fil data:", error);
        const baseReferenceFil = Number(systemConstant.Base_reference_matiere_fil) || 20000;
        const baseReferencePlastique = Number(systemConstant.Base_reference_matiere_plastique) || 15000;
        const filUnitCost = Number(systemConstant.Coût_fil_unitaire) || 20000;
        const plasticUnitCost = Number(systemConstant.Coût_plastique_unitaire) || 15000;
        const filCost = totalExport * (filUnitCost / baseReferenceFil);
        const plastiqueCost = totalExport * (plasticUnitCost / baseReferencePlastique);

        setFils(filCost);
        setFilsParChain(filCost);
        setPlastique(plastiqueCost);
        setPlastiqueParChain(plastiqueCost);
        
        console.log("💰 Error Fallback Calculation Results:");
        console.log(`  - Fil cost per chain: ${filCost}`);
        console.log(`  - Plastic cost per chain: ${plastiqueCost}`);
      }
      console.log("🔍 === END CALCULATION ===");
    };

    const calculateCouteFilAndPlastiquePre = () => {
      const baseReferenceFil = Number(systemConstant.Base_reference_matiere_fil) || 20000;
      const baseReferencePlastique = Number(systemConstant.Base_reference_matiere_plastique) || 15000;
      const filUnitCost = Number(systemConstant.Coût_fil_unitaire) || 20000;
      const plasticUnitCost = Number(systemConstant.Coût_plastique_unitaire) || 15000;
      const filCost = planTotal * (filUnitCost / baseReferenceFil);
      const plastiqueCost = planTotal * (plasticUnitCost / baseReferencePlastique);

      setFilsParChainPre(filCost);
      setPlastiqueParChainPre(plastiqueCost);
      
      console.log("🔍 === CALCULATION: Fil et Plastique Pre par chaine ===");
      console.log("📊 Input Data:");
      console.log("  - planTotal:", planTotal);
      console.log("  - totalChains:", totalChains);
      console.log("💰 Pre-calculation Results:");
      console.log(`  - Fil cost per chain: ${filCost}`);
      console.log(`  - Plastic cost per chain: ${plastiqueCost}`);
      console.log("🔍 === END CALCULATION ===");
    };

    
    const calculateCoûtEnergie = () => {
      const { Coût_énergie_journalier, Nombre_d_heures_par_jour } =
        systemConstant;
      const Nombre_de_jours_de_production = totalHours / Nombre_d_heures_par_jour;
      setCoûtEnergie(Nombre_de_jours_de_production * Coût_énergie_journalier);
    };

    const calculateCoûtEnergieParChain = () => {
      const { Coût_énergie_journalier, Nombre_d_heures_par_jour } =
        systemConstant;
      const Nombre_de_jours_de_production = totalHours / Nombre_d_heures_par_jour;
      const energyCost = (Nombre_de_jours_de_production * Coût_énergie_journalier) / totalChains;
      
      console.log("🔍 === CALCULATION: Energy Cost per Chain ===");
      console.log("📊 Input Data:");
      console.log("  - totalHours:", totalHours);
      console.log("  - Nombre_d_heures_par_jour:", Nombre_d_heures_par_jour);
      console.log("  - Coût_énergie_journalier:", Coût_énergie_journalier);
      console.log("  - totalChains:", totalChains);
      
      console.log("🧮 Energy Calculations:");
      console.log(`  - Production days: ${Nombre_de_jours_de_production}`);
      console.log(`  - Total energy cost: ${Nombre_de_jours_de_production * Coût_énergie_journalier}`);
      console.log(`  - Energy cost per chain: ${energyCost}`);
      
      setCoûtEnergieParChain(energyCost);
      console.log("🔍 === END CALCULATION ===");
    };

    const calculateCoûtChargesFixes = () => {
      const { Coût_charges_fixes_journalier, Nombre_d_heures_par_jour } =
          systemConstant;
      const Nombre_de_jours_de_production = totalHours / Nombre_d_heures_par_jour;
      setCoûtChargesFixes(
        Nombre_de_jours_de_production * Coût_charges_fixes_journalier
      );
    };

    const calculateCoûtChargesFixesParChain = () => {
      const { Coût_charges_fixes_journalier, Nombre_d_heures_par_jour } =
          systemConstant;
      const Nombre_de_jours_de_production = totalHours / Nombre_d_heures_par_jour;
      const fixedChargesCost = (Nombre_de_jours_de_production * Coût_charges_fixes_journalier) / totalChains;
      
      console.log("🔍 === CALCULATION: Fixed Charges Cost per Chain ===");
      console.log("📊 Input Data:");
      console.log("  - totalHours:", totalHours);
      console.log("  - Nombre_d_heures_par_jour:", Nombre_d_heures_par_jour);
      console.log("  - Coût_charges_fixes_journalier:", Coût_charges_fixes_journalier);
      console.log("  - totalChains:", totalChains);
      
      console.log("🧮 Fixed Charges Calculations:");
      console.log(`  - Production days: ${Nombre_de_jours_de_production}`);
      console.log(`  - Total fixed charges cost: ${Nombre_de_jours_de_production * Coût_charges_fixes_journalier}`);
      console.log(`  - Fixed charges cost per chain: ${fixedChargesCost}`);
      
      setCoûtChargesFixesParChain(fixedChargesCost);
      console.log("🔍 === END CALCULATION ===");
    };

    
      // This calculates the TOTAL MODEL COST (dépôt final) - not per chain
      const calculateCoûtDeRevient = () => {
        // For "Coût de revient réel dépôt final" we need TOTAL model costs, not per chain costs
        // because this represents the total model production, not individual chain production
        
        // We need to get the total fil/plastic costs for the whole model
        // For now, let's calculate it by multiplying per chain costs by total chains
        // But ideally, we should fetch the total model costs directly
        
        const totalFilCost = parseFloat(fils) * totalChains; // Convert per chain to total model
        const totalPlastiqueCost = parseFloat(plastique) * totalChains; // Convert per chain to total model
        
        const totalCost =
          totalFilCost +
          totalPlastiqueCost +
          parseFloat(totalMassSalary) +
          parseFloat(couteTransport) +
          parseFloat(coûtChargesFixes) +
          parseFloat(coûtEnergie);
    
        console.log("🔍 === CALCULATION: Coût de revient réel dépôt final ===");
        console.log("📊 Input Data (converted to total model costs):");
        console.log("  - totalFilCost (fils * totalChains):", totalFilCost);
        console.log("  - totalPlastiqueCost (plastique * totalChains):", totalPlastiqueCost);
        console.log("  - totalMassSalary:", parseFloat(totalMassSalary));
        console.log("  - couteTransport:", parseFloat(couteTransport));
        console.log("  - coûtChargesFixes:", parseFloat(coûtChargesFixes));
        console.log("  - coûtEnergie:", parseFloat(coûtEnergie));
        console.log("🧮 Total Cost:", totalCost);
        console.log("🔍 === END CALCULATION ===");
        
        setCoûtDeRevient(totalCost.toFixed(2));
      };

      // This calculates the cost for a SPECIFIC CHAIN (per chain)
      const calculateCoûtDeRevientParChain = () => {
        console.log("🔍 === CALCULATION: Coût de revient réel chaine ===");
        console.log("📊 Input Data:");
        console.log("  - filsParChain:", filsParChain);
        console.log("  - plastiqueParChain:", plastiqueParChain);
        console.log("  - totalMassSalaryParChain:", totalMassSalaryParChain);
        console.log("  - couteTransportParChain:", couteTransportParChain);
        console.log("  - coûtChargesFixesParChain:", coûtChargesFixesParChain);
        console.log("  - coûtEnergieParChain:", coûtEnergieParChain);
        
        const totalCost =
          parseFloat(filsParChain) +
          parseFloat(plastiqueParChain) +
          parseFloat(totalMassSalaryParChain) +
          parseFloat(couteTransportParChain) +
          parseFloat(coûtChargesFixesParChain) +
          parseFloat(coûtEnergieParChain);
        
        console.log("🧮 Calculation Breakdown:");
        console.log(`  - Fil cost: ${parseFloat(filsParChain)}`);
        console.log(`  - Plastic cost: ${parseFloat(plastiqueParChain)}`);
        console.log(`  - Salary mass: ${parseFloat(totalMassSalaryParChain)}`);
        console.log(`  - Transport cost: ${parseFloat(couteTransportParChain)}`);
        console.log(`  - Fixed charges: ${parseFloat(coûtChargesFixesParChain)}`);
        console.log(`  - Energy cost: ${parseFloat(coûtEnergieParChain)}`);
        console.log(`  - TOTAL: ${totalCost}`);
        
        setCoûtDeRevientParChain(totalCost.toFixed(2));
        console.log("✅ Final result:", totalCost.toFixed(2));
        console.log("🔍 === END CALCULATION ===");
      };

      const calculateCoûtDeRevientParChainPre = () => {
        const totalCost =
          parseFloat(filsParChainPre) +
          parseFloat(plastiqueParChainPre) +
          parseFloat(totalMassSalaryParChainPre) +
          parseFloat(couteTransportParChainPre) +
          parseFloat(coûtChargesFixesParChain) +
          parseFloat(coûtEnergieParChain);
    
        setCoûtDeRevientParChainPre(totalCost.toFixed(2));
      };



        useEffect(() => {
          if (
            totalHours > 0 &&
            effectifDirect > 0 &&
            effectifInDirect > 0 &&
            totalChains > 0 &&
            systemConstant.Nombre_d_heures_par_jour
          ) {
            console.log("🚀 === TRIGGERING ALL CALCULATIONS ===");
            console.log("📊 Current State:", {
              totalHours,
              effectifDirect,
              effectifInDirect,
              totalChains,
              totalExport,
              selectedModel,
              selectedChain
            });
            
            calculateCouteTransport();
            calculateTotalMasseSalariale();
            calculateCoûtEnergie();
            calculateCoûtChargesFixes();

            calculateCouteTransportParChain();
            calculateTotalMasseSalarialeParChain();
            calculateCouteFilAndPlastique(); // This is now async
            calculateCoûtEnergieParChain();
            calculateCoûtChargesFixesParChain();

            calculateCouteTransportParChainPre();
            calculateTotalMasseSalarialeParChainPre()
            calculateCouteFilAndPlastiquePre();
            
            console.log("✅ All calculations triggered");
            console.log("🚀 === END TRIGGERING ===");
          } else {
            console.log("⚠️ Calculations not triggered - missing data:", {
              totalHours: totalHours > 0,
              effectifDirect: effectifDirect > 0,
              effectifInDirect: effectifInDirect > 0,
              totalChains: totalChains > 0,
              hasSystemConstant: !!systemConstant.Nombre_d_heures_par_jour
            });
          }
        }, [
          totalHours,
          effectifDirect,
          effectifInDirect,
          totalChains,
          totalExport,
          systemConstant,
          selectedModel, // Added selectedModel dependency
          selectedChain, // Added selectedChain dependency
        ]);
      
        useEffect(() => {
          if (selectedModel) {
            fetchWorkedHours(selectedModel);
          }
        }, [selectedModel]);
      
        useEffect(() => {
           calculateCoûtDeRevient();
        },  [
            fils,
            plastique,
            totalMassSalary,
            couteTransport,
            coûtChargesFixes,
            coûtEnergie,
          ])

          useEffect(() => {
            calculateCoûtDeRevientParChain();
         },  [
             filsParChain,
             plastiqueParChain,
             totalMassSalaryParChain,
             couteTransportParChain,
             coûtChargesFixesParChain,
             coûtEnergieParChain,
           ])
        
           useEffect(() => {
            calculateCoûtDeRevientParChainPre();
         },  [
             filsParChainPre,
             plastiqueParChainPre,
             totalMassSalaryParChainPre,
             couteTransportParChainPre,
             coûtChargesFixesParChainPre,
             coûtEnergieParChainPre,
           ])


           const calculateMargeBruteDepot = () => {
            const margeBrute = parseFloat(productionDepotValeur) - coûtDeRevient;
            return margeBrute;
          };

          const calculateMargeBruteDepotParChain = () => {
            const margeBrute = parseFloat(productionDepotValeurChain) - coûtDeRevientParChain;
            return margeBrute;
          };

          const calculateMargeBruteDepotParChainPre = () => {
            const margeBrute = parseFloat(productionDepotValeurChainpre) - coûtDeRevientParChainPre;
            return margeBrute
          }


           const calculateMargeNetteDepot = () => {
            const margeBruteDepot = calculateMargeBruteDepot();
            const margeNette = margeBruteDepot - margeBruteDepot * 0.2;
            setMargeNetteDepot(margeNette.toFixed(2));
          };

          const calculateMargeNetteDepotParChain = () => {
            const margeBruteDepot = calculateMargeBruteDepotParChain();
            const margeNette = margeBruteDepot - margeBruteDepot * 0.2;
            setMargeNetteDepotParChain(margeNette.toFixed(2));
          }

          const calculateMargeNetteDepotParChainPre = () => {
            const margeBruteDepot = calculateMargeBruteDepotParChainPre();
            const margeNette = margeBruteDepot - margeBruteDepot * 0.2;
            setMargeNetteDepotParChainPre(margeNette.toFixed(2));
          }
        
          useEffect(() => {
            calculateMargeNetteDepotParChainPre()
          }, [
            coûtDeRevientParChainPre,
            productionDepotValeurChainpre,
          ])

          useEffect(() => {
            calculateMargeNetteDepot()
          }, [
            coûtDeRevient,
            productionDepotValeur,
          ])

          useEffect(() => {
            calculateMargeNetteDepotParChain()
          }, [
            productionDepotValeurChain,
            coûtDeRevientParChain,
          ])

        // Trigger model data fetching when model is selected
        useEffect(() => {
            if (selectedModel && selectionType === "model") {
                getMargeNetteTotalForModel(selectedModel);
            }
        }, [selectedModel, selectionType]);

        // Trigger chain data fetching when chain is selected
        useEffect(() => {
            if (selectedChain && selectionType === "chain") {
                calculateMargeNetteForChain(selectedChain);
            }
        }, [selectedChain, selectionType]);

        // Trigger chain calculations when chain data is available
        useEffect(() => {
            if (chainTotalHours > 0 && chainEffectifDirect > 0 && chainEffectifInDirect > 0 && systemConstant.Nombre_d_heures_par_jour) {
                console.log("🚀 === TRIGGERING CHAIN CALCULATIONS ===");
                console.log("📊 Chain Data Available:", {
                    chainTotalHours,
                    chainEffectifDirect,
                    chainEffectifInDirect,
                    systemConstant: !!systemConstant.Nombre_d_heures_par_jour
                });
                
                calculateChainTotalMasseSalariale();
                calculateChainCouteTransport();
                calculateChainCoûtEnergie();
                calculateChainCoûtChargesFixes();
                calculateChainCouteFil();
                
                console.log("✅ Chain calculations triggered");
            }
        }, [chainTotalHours, chainEffectifDirect, chainEffectifInDirect, systemConstant, workedHoursByDate, effectiveDataByDate, effectiveIndirectDataByDate, cle, chainTotalExport]);

        // Trigger depot calculations when model data is available
        useEffect(() => {
            if (workedHoursByDate && effectiveIndirectDataByDate && systemConstant && cle) {
                console.log("🚀 === TRIGGERING DEPOT CALCULATIONS ===");
                console.log("📊 Depot Data Available:", {
                    workedHoursByDate: !!workedHoursByDate,
                    effectiveIndirectDataByDate: !!effectiveIndirectDataByDate,
                    systemConstant: !!systemConstant,
                    cle: !!cle
                });
                
                calculateModelDepotTransportCost();
                calculateModelDepotMassSalary();
                
                console.log("✅ Depot calculations triggered");
            }
        }, [workedHoursByDate, effectiveIndirectDataByDate, systemConstant, cle]);

        // Calculate final depot cost when all components are ready
        useEffect(() => {
            if (modelDepotTransportCost > 0 || modelDepotMassSalary > 0) {
                console.log("🚀 === TRIGGERING DEPOT TOTAL COST CALCULATION ===");
                calculateModelDepotTotalCost();
            }
        }, [modelDepotTransportCost, modelDepotMassSalary]);

        // Calculate final chain cost when all components are ready
        useEffect(() => {
            if (chainTotalMassSalary > 0 && chainCouteTransport > 0 && chainCoûtEnergie > 0 && chainCoûtChargesFixes > 0 && chainFilsParChain > 0) {
                const totalCost = calculateChainCoûtDeRevient();
                let netMargin = chainProductionValue - totalCost;
                if(netMargin > 0) {
                    netMargin = netMargin - netMargin * 0.2;
                }

                const netMarginRate = chainProductionValue > 0 ? (netMargin / chainProductionValue) * 100 : 0;
                
                setChainNetMargin(parseFloat(netMargin.toFixed(2)));
                setChainNetMarginRate(parseFloat(netMarginRate.toFixed(2)));
                
                console.log("🎯 === FINAL CHAIN CALCULATIONS ===");
                console.log("📊 Final Results:", {
                    chainProductionValue,
                    totalCost,
                    netMargin,
                    netMarginRate
                });
            }
        }, [chainTotalMassSalary, chainCouteTransport, chainCoûtEnergie, chainCoûtChargesFixes, chainFilsParChain, chainProductionValue]);

        return (
        <div className="ml-7 mt-5">
            <div className="flex items-center justify-between">
                <h2 className="text-2xl font-semibold">Marge réelle Nette</h2>
                <div className="flex items-center gap-4">
                    <div className="mb-4 pr-6">
                        <label className="block text-sm font-medium text-gray-700 mb-2">Select Model</label>
                        <ModelSelect className="mt-4" value={selectedModel} onChange={handleModelSelectChange} models={models} />
                    </div>
                    <div className="mb-4 pr-6">
                        <label className="block text-sm font-medium text-gray-700 mb-2">Select Chain</label>
                        <select
                            className="block w-full mt-4 outline-0 p-[.5rem] border border-[#b3b3b3] focus:border-2 focus:border-[#2684ff] rounded"
                            value={selectedChain}
                            onChange={handleChainSelectChange}
                        >
                            <option value="">Choisir une chaîne</option>
                            {chains.map((chain) => (
                                <option key={chain.id} value={chain.id}>
                                    {chain.name}
                                </option>
                            ))}
                        </select>
                    </div>
                </div>
            </div>   
            {/* Model Selection Table */}
            {selectionType === "model" && modelChains.length > 0 && (
                <div className="overflow-x-auto mt-5">
                    <table className="table-auto w-full bg-slate-200 border-collapse border border-gray-300 shadow-md">
                        <thead className="bg-gray-100">
                            <tr>
                                <th className="px-6 py-3 min-w-[200px] text-left text-xs font-medium text-[#4E4A4A] uppercase tracking-wider border border-gray-300">Modèle</th>
                                <th className="px-6 py-3 min-w-[200px] text-left text-xs font-medium text-[#4E4A4A] uppercase tracking-wider border border-gray-300">Client</th>
                                <th className="px-6 py-3 min-w-[200px] text-left text-xs font-medium text-[#4E4A4A] uppercase tracking-wider border border-gray-300">Prix main d'œuvre</th>
                                <th className="px-6 py-3 min-w-[200px] text-left text-xs font-medium text-[#4E4A4A] uppercase tracking-wider border border-gray-300">Photo</th>
                                <th className="px-6 py-3 min-w-[200px] text-left text-xs font-medium text-[#4E4A4A] uppercase tracking-wider border border-gray-300">Chaines</th>
                                <th className="px-6 py-3 min-w-[200px] text-left text-xs font-medium text-[#4E4A4A] uppercase tracking-wider border border-gray-300">Production réelle dépôt</th>
                                <th className="px-6 py-3 min-w-[200px] text-left text-xs font-medium text-[#4E4A4A] uppercase tracking-wider border border-gray-300">Production depot en valeur</th>
                                <th className="px-6 py-3 min-w-[200px] text-left text-xs font-medium text-[#4E4A4A] uppercase tracking-wider border border-gray-300">Coût de revient réel dépôt final</th>
                                <th className="px-6 py-3 min-w-[200px] text-left text-xs font-medium text-[#4E4A4A] uppercase tracking-wider border border-gray-300">Marge nette réelle de l'article en dépôt final</th>
                                <th className="px-6 py-3 min-w-[200px] text-left text-xs font-medium text-[#4E4A4A] uppercase tracking-wider border border-gray-300">Taux de marge nette réelle de l'article en dépôt final</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <th className="p-[2rem] min-w-[200px] text-left text-[#4E4A4A] border font-semibold border border-gray-300">
                                    {models.find(m => m.id == selectedModel)?.modele || ""}
                                </th>
                                <th className="p-[2rem] min-w-[200px] text-left text-[#4E4A4A] border font-semibold border border-gray-300">
                                    {models.find(m => m.id == selectedModel)?.client || ""}
                                </th>
                                <th className="p-[2rem] min-w-[200px] text-left text-[#4E4A4A] border font-semibold border border-gray-300">
                                    {models.find(m => m.id == selectedModel)?.prixMOver || ""}
                                </th>
                                <th className="p-[2rem] min-w-[200px] text-left text-[#4E4A4A] border font-semibold border border-gray-300">
                                    <img
                                        src={`https://api.crosscheckconf.net${models.find(m => m.id == selectedModel)?.image || ""}`}
                                        alt={models.find(m => m.id == selectedModel)?.modele || ""}
                                        className="h-[50px] w-[50px]"
                                    />
                                </th>
                                <th className="p-[2rem] min-w-[200px] text-left text-[#4E4A4A] border font-semibold border border-gray-300">
                                    {modelChains.map(chain => chain.chainName).join(", ")}
                                </th>
                                <th className="p-[2rem] min-w-[200px] text-left text-[#4E4A4A] border font-semibold border border-gray-300">
                                     {modelDepotFinalValue}
                                </th>
                                <th className="p-[2rem] min-w-[200px] text-left text-[#4E4A4A] border font-semibold border border-gray-300">
                                    {typeof modelProductionValue === 'number' ? modelProductionValue.toFixed(2) : '0.00'}
                                </th>
                                <th className="p-[2rem] min-w-[200px] text-left text-[#4E4A4A] border font-semibold border border-gray-300">
                                    {typeof modelTotalCost === 'number' ? modelTotalCost.toFixed(2) : '0.00'}
                                </th>
                                <th className="p-[2rem] min-w-[200px] text-left text-[#4E4A4A] border font-semibold border border-gray-300">
                                    {typeof modelNetMargin === 'number' ? modelNetMargin.toFixed(2) : '0.00'}
                                </th>
                                <th className="p-[2rem] min-w-[200px] text-left text-[#4E4A4A] border font-semibold border border-gray-300">
                                    {typeof modelNetMarginRate === 'number' ? modelNetMarginRate.toFixed(2) : '0.00'}%
                                </th>
                            </tr>
                        </tbody>
                    </table>
                </div>
            )}

            {/* Chain Selection Table */}
            {selectionType === "chain" && model && (
                <div className="overflow-x-auto mt-5">
                    <table className="table-auto w-full bg-slate-200 border-collapse border border-gray-300 shadow-md">
                        <thead className="bg-gray-100">
                            <tr>
                                <th className="px-6 py-3 min-w-[200px] text-left text-xs font-medium text-[#4E4A4A] uppercase tracking-wider border border-gray-300">Modèle</th>
                                <th className="px-6 py-3 min-w-[200px] text-left text-xs font-medium text-[#4E4A4A] uppercase tracking-wider border border-gray-300">Client</th>
                                <th className="px-6 py-3 min-w-[200px] text-left text-xs font-medium text-[#4E4A4A] uppercase tracking-wider border border-gray-300">Prix main d'œuvre</th>
                                <th className="px-6 py-3 min-w-[200px] text-left text-xs font-medium text-[#4E4A4A] uppercase tracking-wider border border-gray-300">Photo</th>
                                <th className="px-6 py-3 min-w-[200px] text-left text-xs font-medium text-[#4E4A4A] uppercase tracking-wider border border-gray-300">Production réelle chaine</th>
                                <th className="px-6 py-3 min-w-[200px] text-left text-xs font-medium text-[#4E4A4A] uppercase tracking-wider border border-gray-300">Production chain en valeur</th>
                                <th className="px-6 py-3 min-w-[200px] text-left text-xs font-medium text-[#4E4A4A] uppercase tracking-wider border border-gray-300">Coût de revient réel chaine</th>
                                <th className="px-6 py-3 min-w-[200px] text-left text-xs font-medium text-[#4E4A4A] uppercase tracking-wider border border-gray-300">Marge nette réelle par chaine</th>
                                <th className="px-6 py-3 min-w-[200px] text-left text-xs font-medium text-[#4E4A4A] uppercase tracking-wider border border-gray-300">Taux de marge nette réelle par chaine</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <th className="p-[2rem] min-w-[200px] text-left text-[#4E4A4A] border font-semibold border border-gray-300">{model.modele}</th>
                                <th className="p-[2rem] min-w-[200px] text-left text-[#4E4A4A] border font-semibold border border-gray-300">{model.client}</th>
                                <th className="p-[2rem] min-w-[200px] text-left text-[#4E4A4A] border font-semibold border border-gray-300">{model.prixMOver}</th>
                                <th className="p-[2rem] min-w-[200px] text-left text-[#4E4A4A] border font-semibold border border-gray-300">
                                    <img
                                        src={`https://api.crosscheckconf.net${model.image}`}
                                        alt={model.name}
                                        className="h-[50px] w-[50px]"
                                    />
                                </th>
                                <th className="p-[2rem] min-w-[200px] text-left text-[#4E4A4A] border font-semibold border border-gray-300">{selectedChainSortie}</th>
                                <th className="p-[2rem] min-w-[200px] text-left text-[#4E4A4A] border font-semibold border border-gray-300">
                                    {typeof chainProductionValue === 'number' ? chainProductionValue.toFixed(2) : '0.00'}
                                </th>
                                <th className="p-[2rem] min-w-[200px] text-left text-[#4E4A4A] border font-semibold border border-gray-300">
                                    {typeof chainTotalCost === 'number' ? chainTotalCost.toFixed(2) : '0.00'}
                                </th>
                                <th className="p-[2rem] min-w-[200px] text-left text-[#4E4A4A] border font-semibold border border-gray-300">
                                    {typeof chainNetMargin === 'number' ? chainNetMargin.toFixed(2) : '0.00'}
                                </th>
                                <th className="p-[2rem] min-w-[200px] text-left text-[#4E4A4A] border font-semibold border border-gray-300">
                                    {typeof chainNetMarginRate === 'number' ? chainNetMarginRate.toFixed(2) : '0.00'}%
                                </th>
                            </tr>
                        </tbody>
                    </table>
                </div>
            )}

            {/* No Selection Message */}
            {!selectionType && (
                <div className="mt-5 p-4 bg-gray-100 rounded-lg">
                    <p className="text-gray-600 text-center">
                        Veuillez sélectionner un modèle ou une chaîne pour afficher les données.
                    </p>
                </div>
            )}
        </div>
    )
}

export default MargeNetteTable
